<ng-template #classic let-c="close" let-d="dismiss" id="download-modal">
    <div class="modal-content">
        <div class="text-center mb-3">
            <span>{{ 'CONSTANTS.DOWNLOADING' | translate }}...</span>
        </div>
        <app-loader-css></app-loader-css>
    </div>
</ng-template>